import { useEffect } from 'react';

import { Card, ModalButton } from '~src/components/display';
import { OfferProfitMargins } from '~src/components/display/OfferProfitMargins';
import { CustomerNotes } from '~src/components/features/shared/customer';
import { OfferDistrictHeatingComparison, OfferStatistics } from '~src/components/features/shared/offer';
import { OfferExpenseTableNewOffer } from '~src/components/features/shared/offer/OfferExpenseTable';
import { RecommendedHeatEffectOverview } from '~src/components/features/shared/product';
import { HeatPumpIndoorProductSelector } from '~src/components/features/shared/product/HeatPumpIndoorProductSelector';
import { HeatPumpOutdoorProductSelector } from '~src/components/features/shared/product/HeatPumpOutdoorProductSelector';
import { useLocalization, useOfferProductState } from '~src/hooks';
import { OfferProducts } from '~src/types';

import { useCombineOfferProductsWithExpenses } from '../../hooks/useCombineOfferProductsWithExpenses';
import { useSynchronizeStatefulCustomerNotes } from '../../hooks/useSynchronizeStatefulCustomerNotes';
import { useCreateOfferState } from '../../state/createOfferState';

import { displayColumn, displayRow } from '~src/style/shared.module.css';

import { tab } from './product.module.css';

export const CreateOfferHeatPumpTab = () => {
  const translate = useLocalization();

  const { customer, residence, offerList } = useCreateOfferState();
  useSynchronizeStatefulCustomerNotes();

  const { selectedHeatPumpOutdoorUnit, selectedHeatPumpIndoorUnit, setOfferExpenses, selectedOfferExpenses } =
    useOfferProductState();

  useEffect(
    function removeExistingExpenses() {
      setOfferExpenses([]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [offerList.length]
  );

  const offerProducts: OfferProducts = {
    heatPumpOutdoorUnit: selectedHeatPumpOutdoorUnit,
    heatPumpIndoorUnit: selectedHeatPumpIndoorUnit,
  };

  const offerProductsWithExpenses = useCombineOfferProductsWithExpenses(offerProducts);

  return (
    <Card className={tab}>
      <div className={displayRow}>
        <div className={displayColumn}>
          <OfferStatistics customer={customer} offerProducts={offerProductsWithExpenses} residence={residence} />

          {!!residence && !!offerProducts?.heatPumpOutdoorUnit && (
            <ModalButton buttonChildren={translate.DISTRICT_HEATING_COMPARE}>
              <OfferDistrictHeatingComparison
                customer={customer}
                products={offerProductsWithExpenses}
                residence={residence}
              />
            </ModalButton>
          )}

          <RecommendedHeatEffectOverview residence={residence} />
        </div>

        <div className={displayColumn}>
          <CustomerNotes customer={customer} rows={12} />

          <OfferProfitMargins offer={offerProductsWithExpenses} />
        </div>
      </div>

      <HeatPumpOutdoorProductSelector residence={residence} />

      <HeatPumpIndoorProductSelector />

      <br />
      <OfferExpenseTableNewOffer
        expenses={selectedOfferExpenses}
        offerType='heatPump'
        tableTitle={translate.EXPENSE}
        updateExpenses={setOfferExpenses}
      />
    </Card>
  );
};
